import React from "react";
import { useDispatch, useSelector } from "react-redux";
//material ui
import makeStyles from "@material-ui/styles/makeStyles";
import Paper from "@material-ui/core/Paper";
//jazasoft
import { PageHeader, SimpleForm, required, translate, showNotification } from "jazasoft";

// local
import ExcelErrorDialog from "../../../components/ExcelErrorDialog";
import MyFileInput from "../../../components/MyFileInput";
import useSafeState from "../../../hooks/useSafeState";
import useMutation from "../../../hooks/useMutation";
import hasSuperPrivilege from "../../../utils/hasPrivilege";
import { ResourceId, Scope } from "../../../utils/privilege";
import Forbidden from "../../../components/Forbidden";

const mapper = ({ serialNo, field, message }, i18nMap) => {
  const orderMap = i18nMap?.resources?.orders?.fields || {};
  let column = orderMap[field] || field;
  if (typeof column === "object") {
    column = column.name;
  }
  return {
    row: serialNo,
    column,
    message: Array.isArray(message) ? message.join(", ") : message
  };
};

const useStyles = makeStyles(_ => ({
  root: {
    margin: "1.5em",
    padding: "1.5em"
  }
}));

const OrderUpload = props => {
  const { basePath, translate, history, roles = [], hasAccess = () => false } = props;
  const [errorList, setErrorList] = useSafeState([]);

  const i18nMap = useSelector(state => state.i18n?.messages || {});

  const [mutate] = useMutation({ autoHideDuration: 15000 });
  const dispatch = useDispatch();

  const onUpload = values => {
    const { file } = values;
    var data = new FormData();
    data.append("file", file && file.rawFile);
    const options = {
      url: `orders/upload`,
      method: "post",
      data: data,

      headers: { "Content-Type": "multipart/form-data" }
    };

    mutate(options, {
      onSuccess: () => {
        dispatch(showNotification(translate("resources.orders.success.upload", { _: "Orders uploaded successfully" })));
        history.push(basePath);
      },
      onFailure: err => {
        if (err.status === 400 && err.errors && Array.isArray(err.errors)) {
          setErrorList(
            err.errors
              ?.flatMap(e => (Array.isArray(e.errors) ? e.errors.map(e2 => mapper(e2, i18nMap)) : [mapper(e, i18nMap)]))
              .sort((a, b) => a.row - b.row)
          );
        }
      }
    });
  };
  const classes = useStyles();

  if (!hasSuperPrivilege(roles, hasAccess, ResourceId.ORDER, Scope.WRITE)) {
    return <Forbidden history={history} />;
  }

  return (
    <div>
      <PageHeader title="Upload orders" />

      <ExcelErrorDialog maxWidth="xl" open={errorList?.length > 0 || false} errors={errorList} onClose={() => setErrorList(null)} />

      <Paper className={classes.root}>
        <SimpleForm onSubmit={onUpload}>
          <MyFileInput
            source="file"
            label={translate("resources.users.title.excel_file", { _: "Excel file" })}
            // accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            accept={{
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
              "application/vnd.ms-excel": [".xls"]
            }}
            message={translate("js.message.drop_file", { _: "Drag and drop file here, or click to select file" })}
            xs={12}
            fullWidth
            validate={required()}
          />
        </SimpleForm>
      </Paper>
    </div>
  );
};

export default translate(OrderUpload);
